(() => {
  const media = window.matchMedia('(max-width: 749px)');
  const undos = [];
  let observer;
  let queued = false;
  const collapsed = new Set();
  let printStates = [];
  function move(node, parent, before = null) {
    if (!node || !parent || !node.parentNode) return;
    const marker = document.createComment('');
    node.before(marker);
    parent.insertBefore(node, before);
    undos.push(() => { if (marker.parentNode) marker.replaceWith(node); });
  }
  function disclosure(node, label) {
    if (!node || node.closest('.tcp-m-disclosure')) return;
    const details = document.createElement('details');
    details.className = 'tcp-m-disclosure';
    const summary = document.createElement('summary');
    summary.textContent = label;
    node.before(details);
    details.append(summary);
    undos.push(() => details.remove());
    move(node, details);
  }
  function foldInformation(labels) {
    document.querySelectorAll('footer .footer__menu .region-trigger[aria-expanded="true"]').forEach(trigger => {
      if (collapsed.has(trigger)) return;
      collapsed.add(trigger);
      trigger.click();
      undos.push(() => { if (trigger.isConnected && trigger.getAttribute('aria-expanded') === 'false') trigger.click(); });
    });
    document.querySelectorAll('footer .footer__newsletter').forEach(node => {
      const item = node.closest('.footer__item');
      disclosure(item, node.querySelector('.h6')?.textContent.trim() || labels.newsletter);
    });
    document.querySelectorAll('.tc-policy-nav details[open]').forEach(node => {
      if (collapsed.has(node)) return;
      collapsed.add(node);
      node.open = false;
      undos.push(() => { node.open = true; });
    });
    document.querySelectorAll('.tc-recipe-card').forEach(node => {
      disclosure(node, node.querySelector('h3')?.textContent.trim() || labels.recipe);
      node.closest('.tcp-m-disclosure').classList.add('tcp-m-recipe');
    });
    document.querySelectorAll('.tccalc > .tc-intro').forEach(node => disclosure(node, labels.calculator));
    document.querySelectorAll('.tcr.tcr-cards,.tcr.tcr-feature,.tcr.tcr-steps,.tcr.tcr-invite').forEach(node => {
      disclosure(node, node.querySelector('h2')?.textContent.trim() || labels.membership);
      node.closest('.tcp-m-disclosure').classList.add('tcp-m-rewards-fold');
    });
    const join = document.querySelector('.tcr.tcr-join');
    if (join && !join.querySelector('.tcp-m-rewards-note')) {
      const note = document.createElement('div');
      note.className = 'tcp-m-rewards-note';
      const copy = document.createElement('p');
      copy.textContent = labels.offerExclusions;
      const link = document.createElement('a');
      link.className = 'tcp-m-button';
      link.href = '/pages/freezer-stock-up-offers';
      link.textContent = labels.specials;
      note.append(copy, link);
      join.querySelector('.tcr-signup').append(note);
      undos.push(() => note.remove());
    }
    document.querySelectorAll('.tcr-terms:not(:has(.tcr-terms)),.tcr-faq .tcr-answer').forEach(node => {
      if (!node.textContent.includes('WELCOME10') || node.querySelector('.tcp-m-offer-exclusions')) return;
      const note = document.createElement('p');
      note.className = 'tcp-m-offer-exclusions';
      note.textContent = labels.offerExclusions;
      node.append(note);
      undos.push(() => note.remove());
    });

  }
  function revealTarget(hash) {
    if (!media.matches || !hash || !document.body.classList.contains('tcp-public-shopping')) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (_) { return; }
    if (!target) return;
    let parent = target.closest('details');
    while (parent) {
      parent.open = true;
      parent = parent.parentElement?.closest('details');
    }
    target.scrollIntoView({block:'start'});
  }
  function cartOptions(event) {
    if (!event.target.matches('input[name="tcp_mobile_plan"]')) return;
    const panel = event.target.closest('.tcp-m-cart-options');
    if (!panel) return;
    const delivery = event.target.value === 'delivery';
    panel.querySelector('[data-tcp-cart-pickup]').hidden = delivery;
    panel.querySelector('[data-tcp-cart-delivery]').hidden = !delivery;
  }
  function apply() {
    if (!media.matches || !document.body.classList.contains('tcp-public-shopping')) return;
    const text = document.getElementById('tcp-mobile-shopping-text');
    let labels = {};
    try {
      labels = JSON.parse(text?.textContent || '{}');
      Object.keys(labels).forEach(key => { labels[key] = new DOMParser().parseFromString(labels[key], 'text/html').body.textContent; });
    } catch (_) { return; }
    document.querySelectorAll('.main-product .product__block-description').forEach(node => disclosure(node, labels.productDetails));
    document.querySelectorAll('.template-collection #mainContent .rich-text .section__description').forEach(node => disclosure(node, labels.aboutRange));
    document.querySelectorAll('.template-collection .tcp-wholesale-category-nav').forEach(node => disclosure(node, labels.otherCategories));
    document.querySelectorAll('.main-product .tcp-product-summary').forEach(node => {
      if (!node.closest('.tcp-m-disclosure')) {
        disclosure(node, labels.packDetails);
        node.closest('.tcp-m-disclosure').classList.add('tcp-m-summary-disclosure');
      }
    });
    const info = document.querySelector('.main-product__info');
    if (info && info.querySelector('.product__block-buy_buttons form') && !info.querySelector('.tcp-m-product-state')) {
      const note = document.createElement('p');
      note.className = 'tcp-m-product-state';
      const title = info.querySelector('.product__title')?.textContent || '';
      const state = Array.from(info.querySelectorAll('.product__block-collapsible_item p')).find(node => /^Product state:/i.test(node.textContent.trim()));
      note.textContent = /par-cooked/i.test(title) ? labels.parCooked : state ? `${state.textContent.trim()} ${labels.photoPreparation}` : labels.preparation;
      info.append(note);
      undos.push(() => note.remove());
    }
    if (info && info.querySelector('.product__block-buy_buttons form') && !info.querySelector('.tcp-m-product-pickup')) {
      const note = document.createElement('div');
      note.className = 'tcp-m-product-pickup';
      const strong = document.createElement('strong');
      strong.textContent = labels.pickup;
      const copy = document.createElement('div');
      copy.textContent = labels.productDelivery;
      note.append(strong, copy);
      info.append(note);
      undos.push(() => note.remove());
    }
    const cart = document.querySelector('#mainCartForm');
    document.querySelectorAll('.template-cart .cart__note').forEach(node => {
      const parent = node.parentElement;
      const panel = parent.querySelector('.tcp-m-cart-options');
      const discount = parent.querySelector(':scope > .cart__discount');
      if (panel && discount && (discount.compareDocumentPosition(panel) & Node.DOCUMENT_POSITION_FOLLOWING)) move(discount, parent);
      if (panel && (node.compareDocumentPosition(panel) & Node.DOCUMENT_POSITION_FOLLOWING)) move(node, parent);
    });
    foldInformation(labels);
    if (cart) document.body.dataset.tcpMobileCart = 'true';
  }
  function cleanup() {
    observer?.disconnect();
    observer = null;
    while (undos.length) undos.pop()();
    collapsed.clear();
    delete document.body.dataset.tcpMobileCart;
  }
  function update() {
    cleanup();
    if (!media.matches) return;
    apply();
    if (location.hash) revealTarget(location.hash);
    observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        observer?.disconnect();
        apply();
        if (media.matches) observer?.observe(document.getElementById('mainContent'), {childList:true,subtree:true});
      });
    });
    const main = document.getElementById('mainContent');
    if (main) observer.observe(main, {childList:true,subtree:true});
  }
  document.addEventListener('change', cartOptions);
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href*="#"]');
    if (!anchor) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname) revealTarget(url.hash);
  });
  window.addEventListener('hashchange', () => revealTarget(location.hash));
  window.addEventListener('beforeprint', () => {
    printStates = Array.from(document.querySelectorAll('.tcp-m-disclosure'), node => [node, node.open]);
    printStates.forEach(([node]) => { node.open = true; });
  });
  window.addEventListener('afterprint', () => { printStates.forEach(([node, open]) => { node.open = open; }); printStates = []; });
  media.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once:true});
  else update();
})();

(() => {
  const media = window.matchMedia('(max-width: 749px)');
  const home = document.getElementById('tcp-mobile-home');
  const text = document.getElementById('tcp-quick-cart-text');
  if (!home || !text || !document.body.classList.contains('tcp-public-shopping')) return;
  let labels;
  try { labels = JSON.parse(text.textContent); } catch (_) { return; }
  const bar = home.querySelector('[data-tcp-quick-cart]');
  if (!bar) return;
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  function showUnconfirmed() {
    bar.hidden = false;
    bar.querySelector('[data-tcp-quick-cart-count]').hidden = true;
    bar.querySelector('[data-tcp-quick-cart-total]').hidden = true;
  }
  function showCart(cart) {
    const count = Number(cart.item_count);
    if (!Number.isFinite(count)) return;
    bar.hidden = count === 0;
    const countNode = bar.querySelector('[data-tcp-quick-cart-count]');
    countNode.textContent = '· ' + count + ' ' + (count === 1 ? labels.item : labels.items);
    countNode.hidden = false;
    const total = bar.querySelector('[data-tcp-quick-cart-total]');
    try {
      total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:cart.currency || 'AUD'}).format(cart.total_price / 100);
      total.hidden = false;
    } catch (_) { total.hidden = true; }
    document.querySelectorAll('.tc-header__cart').forEach(link => {
      const badge = link.querySelector('.tc-header__count');
      if (badge) badge.textContent = String(count);
      link.setAttribute('aria-label', labels.cart + ', ' + count + ' ' + (count === 1 ? labels.item : labels.items));
    });
  }
  async function refreshCart() {
    const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('cart');
    showCart(await response.json());
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.tcp-m-card__form') || !home.contains(form) || !media.matches) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    const controls = Array.from(home.querySelectorAll('.tcp-m-card__form button[type="submit"]'), node => [node, node.disabled]);
    controls.forEach(([node]) => { node.disabled = true; });
    const feedback = form.querySelector('[data-tcp-card-feedback]');
    const label = form.querySelector('[data-tcp-add-label]');
    feedback.textContent = '';
    delete feedback.dataset.error;
    form.setAttribute('aria-busy','true');
    label.textContent = labels.adding;
    let confirmed = false;
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
      const data = await response.json();
      if (!response.ok) {
        feedback.dataset.error = 'true';
        feedback.textContent = typeof data.description === 'string' ? data.description : labels.error;
        try { await refreshCart(); } catch (_) { showUnconfirmed(); }
        return;
      }
      confirmed = true;
      feedback.textContent = labels.added;
      try { await refreshCart(); } catch (_) { showUnconfirmed(); }
    } catch (_) {
      feedback.dataset.error = 'true';
      feedback.textContent = confirmed ? labels.added : labels.error;
      showUnconfirmed();
    } finally {
      form.removeAttribute('aria-busy');
      label.textContent = labels.add;
      controls.forEach(([node, disabled]) => { node.disabled = disabled; });
      busy = false;
    }
  }, true);
  window.addEventListener('pageshow', () => { if (media.matches) refreshCart().catch(() => {}); });
  media.addEventListener('change', () => { if (media.matches) refreshCart().catch(() => {}); });
})();
